
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { useGameVariantList } from '@/modules/game/variant/model/list';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_GAME.VARIANT.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, fetchList, actions } = useGameVariantList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Min player', key: 'minPlayer' },
                { type: TableColumnType.Text, label: 'Max player', key: 'maxPlayer' },
                { type: TableColumnType.Boolean, label: 'Has team', key: 'hasTeam' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_GAME.VARIANT.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-dollar-sign',
                        theme: 'info',
                        tooltip: 'Match',
                        to: { name: ROUTE_NAME_GAME.MATCH.INDEX, query: { variantId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_GAME };
    }
});
